const DB_NAME = "agility";
const DB_VERSION = 3;
let dbPromise = null;
function open() {
    if (dbPromise)
        return dbPromise;
    dbPromise = openFresh();
    return dbPromise;
}
function openFresh() {
    return new Promise((resolve, reject) => {
        const req = indexedDB.open(DB_NAME, DB_VERSION);
        req.onupgradeneeded = () => {
            console.info(`[db] upgrade needed for ${DB_NAME} v${DB_VERSION}`);
            const db = req.result;
            if (!db.objectStoreNames.contains("baseline")) {
                db.createObjectStore("baseline");
            }
            if (!db.objectStoreNames.contains("prefs")) {
                db.createObjectStore("prefs");
            }
            if (!db.objectStoreNames.contains("progress")) {
                db.createObjectStore("progress");
            }
            if (!db.objectStoreNames.contains("phoneme-libraries")) {
                db.createObjectStore("phoneme-libraries", { keyPath: "id" });
            }
            if (!db.objectStoreNames.contains("active-library")) {
                db.createObjectStore("active-library");
            }
            // v3: introduce the consumer (app) namespace dimension. Existing
            // un-namespaced records logically belong to the default app
            // (Beatbox Hero); because the default app id maps to the bare key
            // (see storage/namespace.ts appScopedKey), no key rewrite is needed
            // and current users lose nothing. We only record that the migration
            // ran so future app ids get their own namespaced keys.
            if (req.transaction) {
                try {
                    const prefs = req.transaction.objectStore("prefs");
                    prefs.put({ migratedAt: Date.now(), toVersion: DB_VERSION }, "__app-namespace-migration");
                    console.info("[db] v3 migration: existing records mapped into default " +
                        "app namespace (no key rewrite required)");
                }
                catch (err) {
                    console.warn("[db] v3 migration bookkeeping failed", err);
                }
            }
        };
        req.onsuccess = () => {
            const db = req.result;
            db.onclose = () => {
                dbPromise = null;
            };
            resolve(db);
        };
        req.onerror = () => {
            console.error("[db] open failed", req.error);
            dbPromise = null;
            reject(req.error);
        };
    });
}
export async function put(storeName, key, value) {
    const db = await open();
    await new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, "readwrite");
        tx.objectStore(storeName).put(value, key);
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
    });
}
export async function get(storeName, key) {
    const db = await open();
    const value = await new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, "readonly");
        const req = tx.objectStore(storeName).get(key);
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
    });
    return value;
}
export async function putRecord(storeName, value) {
    const db = await open();
    await new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, "readwrite");
        tx.objectStore(storeName).put(value);
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
    });
}
export async function getAll(storeName) {
    const db = await open();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, "readonly");
        const req = tx.objectStore(storeName).getAll();
        req.onsuccess = () => resolve(req.result ?? []);
        req.onerror = () => reject(req.error);
    });
}
export async function del(storeName, key) {
    const db = await open();
    await new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, "readwrite");
        tx.objectStore(storeName).delete(key);
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
    });
}
